import { format as dateFormat } from 'date-fns';

export const formatDateFromString = (dateString: string, format: string) => {
  return formatDate(new Date(dateString), format);
};

export const formatDate = (date: Date | null, localeFormat: string) => {
  if (date instanceof Date && date.toString() !== 'Invalid Date') {
    return dateFormat(date, localeFormat);
  }

  return '';
};
